module.exports = __webpack_public_path__ + "img/ic_home.a966bd41.svg";